import { TdProps } from 'app/common/ui-components/table'

import { headerCellsProps } from './header-cells-props'
import { Entity } from './types'

const defaultCellsProps: Record<string, Partial<TdProps>> = {
  [Entity.Title]: headerCellsProps[Entity.Title],
  [Entity.Date]: headerCellsProps[Entity.Date],
  [Entity.Total]: headerCellsProps[Entity.Total],
}

export const createDataProps = () => {
  return new Proxy(defaultCellsProps, {
    get: function (target, property) {
      const res = target[String(property)]
      if (!res) {
        return defaultCellsProps[Entity.Date]
      }
      return res || {}
    },
  })
}

const defaultTotalCellsProps: Record<string, Partial<TdProps>> = {
  [Entity.Title]: { ...headerCellsProps[Entity.Title], alignLeft: undefined, alignRight: true },
  [Entity.Date]: { ...headerCellsProps[Entity.Date], highlighted: true },
  [Entity.Total]: { ...headerCellsProps[Entity.Total], highlighted: true },
}

export const createTotalDataProps = () => {
  return new Proxy(defaultTotalCellsProps, {
    get: function (target, property) {
      const res = target[String(property)]
      if (!res) {
        return defaultTotalCellsProps[Entity.Date]
      }
      return res || {}
    },
  })
}

export const tdPropsByRowAndColumnKey = ({
  rowKey,
}: {
  side: 'left' | 'right' | 'main'
  rowKey: string
  columnKey: string
}) => {
  const props = {} as Omit<TdProps, 'children' | 'className'>
  if (rowKey.startsWith('orgTitle_')) {
    props.bold = true
  }
  return props
}
